var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"parallax-background w-100 h-100"},[_c('div',{staticClass:"contents",style:(`transform:translateY(${_vm.offset}px);`)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }